import { useState } from 'react';
import { DataTable, Page, Card, Text, Box } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsMachineBrands() {
  const [machinebrands, setMachinebrands] = useLookupStore((state) => [state.machinebrands, state.setMachinebrands]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({
    merk: { type: 'text', label: 'Brand', max: '50', value: '' },
    Werken: { type: 'text', label: 'NL', max: '4000', multi: true, value: '' },
    WerkenFR: { type: 'text', label: 'FR', max: '4000', multi: true, value: '' },
    WerkenDE: { type: 'text', label: 'DE', max: '4000', multi: true, value: '' },
    WerkenUK: { type: 'text', label: 'EN', max: '4000', multi: true, value: '' }
    //ProductTariefID
    //ProductKMID
    //Korting
  });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/machinebrands';
  const title = 'Machine brands';

  const rows = machinebrands.map((item) => [item.merk, getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.counter)]);

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      primaryAction={{ content: 'Add machine brand', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId) }}
    >
      <Box paddingBlockEnd="200">
        <Text>The different texts in the 4 languages are editable when opening the modal or adding a new machine brand.</Text>
      </Box>
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setMachinebrands}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable stickyHeader increasedTableDensity verticalAlign="middle" columnContentTypes={['text', 'numeric']} headings={[<b>Machine brand</b>, <b>Edit</b>]} rows={rows} />
      </Card>
    </Page>
  );
}
